import { postMainApi } from "@Shared/@Utils/ajax";
export const printCalculatorForm = async body => {
  const endpoint = `/calculators/print`;
  return postMainApi(body, endpoint);
};